import { UserPreferences } from "../../model/UserPreferences";
import Storage from "../../core/Storage";
import { SessionData } from "../../model/Session";

export default class LocalStorage implements Storage<LocalStorageAppState> {
    public updateState = (state: Partial<LocalStorageAppState>) => {
        for (let key in state) {
            this.setItem(key as keyof LocalStorageAppState, state[key]);
        }
    }

    public getState = (): LocalStorageAppState => {
        const state = {};

        for (let key in localStorage) {
            state[key] = this.getItem(key as keyof LocalStorageAppState);
        }
        return state as LocalStorageAppState;
    }

    public setItem = (key: keyof LocalStorageAppState, data: any): void => {
        if (data === undefined || data === null) {
            localStorage.removeItem(key);
            return;
        }
        return localStorage.setItem(key, JSON.stringify(data));
    }

    public getItem = (key: keyof LocalStorageAppState): any => {
        const item = localStorage.getItem(key);
        try {
            return item ? JSON.parse(item) : undefined;
        } catch (e) {
            return undefined;
        }
    }
}

export interface LocalStorageAppState {
    authToken?: string,
    preferences?: UserPreferences,
    session?: SessionData,
}
